import { IFieldGroup, IMonitoringAgreementCgsModel } from "types";
import { IMonitoringCgsFields } from "types/monitoringCgsFields";

const monitoringCgsGroupFieldsInitValues: IFieldGroup<IMonitoringCgsFields & Partial<IMonitoringAgreementCgsModel>>[] = [
  {
    groupName: `actual_municipality_address_cadastral_code_is_building_rented`,
    groupLabel: `ბენეფიციარის საქმიანობის განხორციელების ფაქტობრივი მისამართი`,
    fields: [
      {
        name: "actual_municipality",
        label: "რეგიონი/მუნიციპალიტეტი *",
        type: "autocomplete",
        optionName: "municipalities",
        value: "",
      },
      {
        name: "mountainous_settlement",
        label: "მთიანი დასახლება",
        type: "autocomplete",
        optionName: "mountainous_settlements_per_municipality",
        value: "",
      },
      {
        name: "actual_address",
        label: "მისამართი(სოფელი/დაბა/ქუჩა/ნომერი) *",
        type: "text",
        value: "",
      },
      {
        name: "cadastral_code",
        label: "საკადასტრო კოდი *",
        type: "text",
        value: "",
      },
    ],
  },
  {
    groupName: `representative_name_phone_position_id_number_email`,
    groupLabel: `ბენეფიციარის წარმომადგენელი პირი`,
    fields: [
      {
        name: "representative_name",
        label: "სახელი, გვარი *",
        type: "text",
        value: "",
      },
      {
        name: "representative_phone",
        label: "ტელ. ნომერი *",
        type: "text",
        value: "",
      },
      {
        name: "representative_position",
        label: "პოზიცია *",
        type: "text",
        value: "",
      },
      {
        name: "representative_id_number",
        label: "პ/ნ *",
        type: "text",
        value: "",
      },
      {
        name: "representative_email",
        label: "წარმომადგენლის ელ. ფოსტა *",
        type: "text",
        value: "",
      },
    ],
  },
  {
    groupName: `fixed_assets_capital_expenditures_funds_turnover`,
    groupLabel: `პროექტის ფარგლებში ბენეფიციარის მხრიდან შესრულებული აქტივობები`,
    fields: [
      {
        name: "amount_of_used_amount_table",
        label: "",
        type: "table",
        value: "",
        tableSchema: [
          {
            fields: [
              {
                name: "machine_equipment_equipment",
                label: "მანქანა - დანადგარები/აღჭურვილობა",
                type: "number",
                value: 0,
              },
              {
                name: "targeted_machine_equipment_equipment",
                label: "მანქანა - დანადგარები/აღჭურვილობა (მიზნობრივი ხარჯები)",
                type: "number",
                value: 0,
              },
              {
                name: "nontargeted_machine_equipment_equipment",
                label: "მანქანა - დანადგარები/აღჭურვილობა (არამიზნობრივი ხარჯები)",
                disabled: true,
                type: "number",
                value: 0,
              },
            ],
          },

          {
            fields: [
              {
                name: "vehicles_special_technic",
                label: "სატრანსპორტო საშუალებები/სპეც. ტექნიკა",
                type: "number",
                value: 0,
              },
              {
                name: "targeted_vehicles_special_technic",
                label: "სატრანსპორტო საშუალებები/სპეც. ტექნიკა (მიზნობრივი ხარჯები)",
                type: "number",
                value: 0,
              },
              {
                name: "nontargeted_vehicles_special_technic",
                label: "სატრანსპორტო საშუალებები/სპეც. ტექნიკა (არამიზნობრივი ხარჯები)",
                disabled: true,
                type: "number",
                value: 0,
              },
            ],
          },

          {
            fields: [
              {
                name: "purchase_building_land",
                label: "შენობა ნაგებობის/მიწის შეძენა",
                type: "number",
                value: 0,
              },
              {
                name: "targeted_purchase_building_land",
                label: "შენობა ნაგებობის/მიწის შეძენა (მიზნობრივი ხარჯები)",
                type: "number",
                value: 0,
              },
              {
                name: "nontargeted_purchase_building_land",
                label: "შენობა ნაგებობის/მიწის შეძენა (არამიზნობრივი ხარჯები)",
                type: "number",
                disabled: true,
                value: 0,
              },
            ],
          },

          {
            fields: [
              {
                name: "building_repairs",
                label: "მშენებლობა/რემონტი",
                type: "number",
                value: 0,
              },
              {
                name: "targeted_building_repairs",
                label: "მშენებლობა/რემონტი (მიზნობრივი ხარჯები)",
                type: "number",
                value: 0,
              },
              {
                name: "nontargeted_building_repairs",
                label: "მშენებლობა/რემონტი (არამიზნობრივი ხარჯები)",
                disabled: true,
                type: "number",
                value: 0,
              },
            ],
          },

          {
            fields: [
              {
                name: "fixed_assets_capital_expenditures",
                label: "ძირითადი საშუალებები/კაპიტალური დანახარჯები",
                type: "number",
                disabled: true,
                value: 0,
              },
              {
                name: "targeted_fixed_assets_capital_expenditures",
                label: "მიზნობრივი ძირითადი საშუალებები/კაპიტალური დანახარჯები",
                type: "number",
                disabled: true,
                value: 0,
              },
              {
                name: "nontargeted_fixed_assets_capital_expenditures",
                label: "არამიზნობრივი ძირითადი საშუალებები/კაპიტალური დანახარჯები",
                type: "number",
                disabled: true,
                value: 0,
              },
            ],
          },

          {
            fields: [
              {
                name: "funds_turnover",
                label: "საბრუნავი საშუალებები",
                type: "number",
                value: 0,
              },
              {
                name: "targeted_funds_turnover",
                label: "საბრუნავი საშუალებები",
                type: "number",
                value: 0,
              },
              {
                name: "nontargeted_funds_turnover",
                label: "საბრუნავი საშუალებები",
                disabled: true,
                type: "number",
                value: 0,
              },
            ],
          },
          {
            fields: [
              {
                name: "is_repayment_amount",
                label: "სესხი ნაწილობრივ ან სრულად არის წინსწრებით დაფარული",
                type: "checkbox",
                value: 0,
              },
              {
                name: "repayment_amount",
                label: "სესხის ნაწილობრივ/სრულად დაფარვა",
                type: "number",
                colSpan: 2,
                value: 0,
              },
            ]
          },
          {
            fields: [
              {
                name: "used_amount",
                label: "ათვისებული თანხის მოცულობა ₾",
                type: "number",
                disabled: true,
                value: 0,
              },
              {
                name: "targeted_used_amount",
                label: "მიზნობრივად ათვისებული თანხის მოცულობა ₾",
                type: "number",
                disabled: true,
                value: 0,
              },
              {
                name: "nontargeted_used_amount",
                label: "არამიზნობრივად ათვისებული თანხის მოცულობა ₾",
                type: "number",
                disabled: true,
                value: 0,
              },
            ],
          },
        ],
      },
      {
        name: "expenseGroups",
        label: "ხარჯვის დამოწმება",
        type: "expense_groups",
        value: [],
      },
      {
        name: "is_sign_inscription_banner",
        type: "select",
        label: `საქმიანობის განხორციელების ადგილას განთავსებულია აბრა წარწერით - პროექტი განხორციელდა პროგრამის "აწარმოე საქართველოში" მხარდაჭერით`,
        value: undefined,
      },
      {
        name: "is_loan_documentation_provided",
        label: "სრულად არის წარმოდგენილი სესხის ხარჯვის დოკუმენტაცია და მონიტორინგის ჩატარების მოცემული თარიღისთვის სესხი სრულად არის გახარჯული",
        type: "checkbox",
        value: false,
      },
      {
        name: "unfulfilled_used_amount_reason",
        label: "არდაკმაყოფილების მიზეზი",
        type: "textarea",
        value: "",
      },
      {
        name: "unfulfilled_used_amount_month_day",
        label: "დარღვევის აღმოსაფხვრელად მიცემული გონივრული ვადა (თვე/დღე)",
        type: "day",
        value: 0,
      },
      {
        name: "monitoring_new_deadline",
        label: "გამეორებითი მონიტორინგის ჩატარების თარიღი",
        type: "date",
        value: null,
      },
      {
        name: "unfulfilled_used_amount_recommendation_reason",
        label: "დარღვევის აღმოსაფხვრელად მიცემული გონივრული ვადისთვის გაცემული რეკომენდაცია",
        type: "textarea",
        value: "",
      },
      {
        name: "is_fullfilled_used_amount",
        label: "სესხი გახარჯულია მიზნობრივად",
        disabled: true,
        type: "checkbox",
        value: false,
      },
      {
        name: "is_taken_business_loan_leasing",
        type: "select",
        label: "სარგებლობდა საფინანსო ინსტიტუტების ბიზნესის მხარდამჭერი საკრედიტო პროდუქტებით (სესხი/ლიზინგი)",
        value: undefined,
      },
      {
        name: "project_activities",
        value: "",
        type: "autocomplete",
        optionName: "cgs_nace_activities",
        label: "საქმიანობის სფეროები",
      },
      {
        name: "additional_comments",
        label: "დამატებითი კომენტარი",
        type: "textarea",
        value: "",
      },
      // {
      //   name: "is_deadline_approve",
      //   label: "8",
      //   type: "checkbox",
      //   value: true,
      // },
    ],
  },
];

export { monitoringCgsGroupFieldsInitValues };

const props = {
  used_amount: "ათვისებული თანხის მოცულობა ₾",
  targeted_used_amount: "ათვისებული თანხის მოცულობა ₾",
  nontargeted_used_amount: "ათვისებული თანხის მოცულობა ₾",

  fixed_assets_capital_expenditures: "ძირითადი საშუალებები/კაპიტალური ხარჯები;",
  targeted_fixed_assets_capital_expenditures: "ძირითადი საშუალებები/კაპიტალური ხარჯები;",
  nontargeted_fixed_assets_capital_expenditures: "ძირითადი საშუალებები/კაპიტალური ხარჯები;",
  machine_equipment_equipment: "მანქანა-დანადგარები/აღჭურვილობა;",
  targeted_machine_equipment_equipment: "მანქანა-დანადგარები/აღჭურვილობა;",
  nontargeted_machine_equipment_equipment: "მანქანა-დანადგარები/აღჭურვილობა;",
  vehicles_special_technic: "სატრანსპორტო საშუალებები/სპეც. ტექნიკა;",
  targeted_vehicles_special_technic: "სატრანსპორტო საშუალებები/სპეც. ტექნიკა;",
  nontargeted_vehicles_special_technic: "სატრანსპორტო საშუალებები/სპეც. ტექნიკა;",
  purchase_building_land: "შენობა-ნაგებობის/მიწის შეძენა;",
  targeted_purchase_building_land: "შენობა-ნაგებობის/მიწის შეძენა;",
  nontargeted_purchase_building_land: "შენობა-ნაგებობის/მიწის შეძენა;",
  building_repairs: "მშენებლობა / რემონტი;",
  targeted_building_repairs: "მშენებლობა / რემონტი;",
  nontargeted_building_repairs: "მშენებლობა / რემონტი;",
  funds_turnover: "საბრუნავი საშუალებები;",
  targeted_funds_turnover: "საბრუნავი საშუალებები;",
  nontargeted_funds_turnover: "საბრუნავი საშუალებები;",
};

// const test = {
//   "used_amount":{
//     columnOne:["fixed_assets_capital_expenditures"]
//   },

// }
//   fixed_assets_capital_expenditures?: number;
//   machine_equipment_equipment?: number;
//   vehicles_special_technic?: number;
//   purchase_building_land?: number;
//   building_repairs?: number;
//   funds_turnover?: number;
//   targeted_used_amount?: number;
//   targeted_fixed_assets_capital_expenditures?: number;
//   targeted_machine_equipment_equipment?: number;
//   targeted_vehicles_special_technic?: number;
//   targeted_purchase_building_land?: number;
//   targeted_building_repairs?: number;
//   targeted_funds_turnover?: number;
//   nontargeted_used_amount?: number;
//   nontargeted_fixed_assets_capital_expenditures?: number;
//   nontargeted_machine_equipment_equipment?: number;
//   nontargeted_vehicles_special_technic?: number;
//   nontargeted_purchase_building_land?: number;
//   nontargeted_building_repairs?: number;
//   nontargeted_funds_turnover?: number;
//   unfulfilled_used_amount_reason?: string;
//   unfulfilled_fixed_assets_capital_expenditures_reason?: string;
//   unfulfilled_machine_equipment_equipment?: number;
//   unfulfilled_vehicles_special_technic_reason?: string;
//   unfulfilled_purchase_building_land_reason?: string;
//   unfulfilled_building_repairs_reason?: string;
//   unfulfilled_funds_turnover_reason?: string;

// used_amount?: number;
//   fixed_assets_capital_expenditures?: number;
//   machine_equipment_equipment?: number;
//   vehicles_special_technic?: number;
//   purchase_building_land?: number;
//   building_repairs?: number;
//   funds_turnover?: number;
//   targeted_used_amount?: number;
//   targeted_fixed_assets_capital_expenditures?: number;
//   targeted_machine_equipment_equipment?: number;
//   targeted_vehicles_special_technic?: number;
//   targeted_purchase_building_land?: number;
//   targeted_building_repairs?: number;
//   targeted_funds_turnover?: number;
//   nontargeted_used_amount?: number;
//   nontargeted_fixed_assets_capital_expenditures?: number;
//   nontargeted_machine_equipment_equipment?: number;
//   nontargeted_vehicles_special_technic?: number;
//   nontargeted_purchase_building_land?: number;
//   nontargeted_building_repairs?: number;
//   nontargeted_funds_turnover?: number;
//   unfulfilled_used_amount_reason?: string;
//   unfulfilled_fixed_assets_capital_expenditures_reason?: string;
//   unfulfilled_machine_equipment_equipment?: number;
//   unfulfilled_vehicles_special_technic_reason?: string;
//   unfulfilled_purchase_building_land_reason?: string;
//   unfulfilled_building_repairs_reason?: string;
//   unfulfilled_funds_turnover_reason?: string;

// {
//   name: "project_activities",
//   value: "",
//   type: "autocomplete",
//   optionName: "nace_activities",
//   label: "საქმიანობის სფეროები",
// },
